<template>
    <div class="product-training">
        <div class="expert-div-lead" id="learning-eye-protection">
            <div class="expert-responsive-lead">
                <h3><span>EXPERT IN</span><strong>EYE Protection</strong></h3>
                <img src="/images/st-learning/eye-protection/exp-main-eye.png" alt="hand protection">
            </div>
            <div class="expert-div-info" style="text-align:center;" ref="mobileView">
                <h2 style="padding-top:50px;">Rediscover Eye Protection</h2>
                <p class="tspace"><strong>YOU’VE GOT A JOB TO DO AND WEST CHESTER PROTECTIVE GEAR HELPS YOU DO IT SAFELY</strong></p>
                <p style="width:600px; display:inline;">
                    Our products are designed to help shield your eyes and face from impact, debris, dust, splashes and other
                    potential hazards that could present severe injury to the eyes and face. West Chester Protective Gear
                    provides a comprehensive line of solutions for safety eyewear needs.                        
                    <br />
                </p>
            </div>
            <a href="javascript:void(0);" class="expert-read-info">
                <span @mousedown="showMobile" ref="readMore"><small>READ MORE</small><font-awesome-icon :icon="['fas', 'chevron-down']" /></span>
                <span @mousedown="hideMobile" ref="readLess"><small>CLOSE</small><font-awesome-icon :icon="['fas', 'chevron-up']" /></span>
            </a>
        </div>
        <!--expert-lead -->

        <div class="clear" style="border-top: solid 1px #ccc;">&nbsp;</div>

        <div class="expert-div">

            <h2 style="margin-top:50px;">Eyewear Styles</h2>
            <p class="main">
                West Chester Protective Gear produces safety eyewear for industrial workers with one thing in mind...give the workers safety glasses that they want to wear.
            </p>
            <div class="expert-sub-menu">
                <span class="icon icon-hamburger" id="borger-1" @mousedown="burgerClicked('borger-1')"><font-awesome-icon :icon="['fas', 'bars']" /></span>
            </div>

            <div id="tech-th" class="expert-sub-menu-dropdown" ref="top-dropdown">
                <div id="style-th-rimless" style="border-bottom:solid 3px #cd1b00;" ref="style-th-rimless" @mouseover="techHover">
                    <img src="/images/st-learning/eye-protection/img-eyewear-style-rimless-TH.jpg" width="150" height="70" alt="" id="style-th-rimless-img"/>
                    RIMLESS
                </div>
                <div id="style-th-semi-rimless" ref="style-th-semi-rimless" @mouseover="techHover">
                    <img src="/images/st-learning/eye-protection/img-eyewear-style-semi-rimless-TH.jpg" width="150" height="70" alt="" id="style-th-semi-rimless-img"/>
                    SEMI-RIMLESS
                </div>
                <div id="style-th-full-frame" ref="style-th-full-frame" @mouseover="techHover">
                    <img src="/images/st-learning/eye-protection/img-eyewear-style-full-frame-TH.jpg" width="150" height="70" alt="" id="style-th-full-frame-img"/>
                    FULL FRAME
                </div>
                <div id="style-th-hybrid" ref="style-th-hybrid" @mouseover="techHover">
                    <img src="/images/st-learning/eye-protection/img-eyewear-style-hybrid-TH.jpg" width="150" height="70" alt="" id="style-th-hybrid-img"/>
                    HYBRID
                </div>
                <div id="style-th-goggles" ref="style-th-goggles" @mouseover="techHover">
                    <img src="/images/st-learning/eye-protection/img-eyewear-style-goggles-TH.jpg" width="150" height="70" alt="" id="style-th-goggles-img"/>
                    GOGGLES
                </div>

            </div>

            <div id="tech-img">
                <img src="/images/st-learning/eye-protection/img-eyewear-style-rimless---en.jpg" width="700" height="519" alt="" id="style-img-rimless"  ref="style-img-rimless"/>
                <img src="/images/st-learning/eye-protection/img-eyewear-style-semi-rimless---en.jpg" width="700" height="519" alt="" id="style-img-semi-rimless" ref="style-img-semi-rimless" style="display:none;" />
                <img src="/images/st-learning/eye-protection/img-eyewear-style-full-frame---en.jpg" width="700" height="519" alt="" id="style-img-full-frame" ref="style-img-full-frame" style="display:none;" />
                <img src="/images/st-learning/eye-protection/img-eyewear-style-hybrid---en.jpg" width="700" height="519" alt="" id="style-img-hybrid" ref="style-img-hybrid" style="display:none;" />
                <img src="/images/st-learning/eye-protection/img-eyewear-style-goggles---en.jpg" width="700" height="519" alt="" id="style-img-goggles" ref="style-img-goggles" style="display:none;" />
            </div>
            <!--tech-img -->

            <div id="style-txt">

                <div id="style-txt-rimless" ref="style-txt-rimless">
                    <p><strong>RIMLESS DESIGN FEATURES:</strong><br />
                        Lighter weight provides all day user comfort &bull; Unobstructed peripheral vision for users not accustomed to glasses &bull; Superior wraparound lens design for extensive eye coverage and outstanding side shield protetion &bull; Many styles offered in a variety of Over-the-Glass (OTG) styles to fit comfortably over prescription eyewear
                    </p>
                </div>

                <div id="style-txt-semi-rimless" style="display:none;" ref="style-txt-semi-rimless">
                    <p><strong>SEMI-RIMLESS DESIGN FEATURES:</strong><br />
                        Half-frame design, lighter for all day comfort &bull; Wraparound lens design with enhanced peripheral protection and distortion-free viewing &bull; Offered in a variety of temple styles and colors &bull; Many styles incorporate adjustable nose pads and temples for all head shapes &bull; Style to meet every price point
                    </p>
                </div>

                <div id="style-txt-full-frame" style="display:none;" ref="style-txt-full-frame">
                    <p><strong>FULL FRAME DESIGN FEATURES:</strong><br />
                        Sportier, lighter weight full frame designs ensure comfort in any situation &bull; Multiple styles to meet your budget and fit requirements.
                    </p>
                </div>

                <div id="style-txt-hybrid" style="display:none;" ref="style-txt-hybrid">
                    <p><strong>HYBRID DESIGN FEATURES:</strong><br />
                        Soft foam padding forms a seal to keep out dust and airborne particles &bull; Temples and strap interchange in seconds… easily converts from a safety glass to a dust goggle and back &bull; Ventilated frame to improve airflow and reduce fogging &bull; Anti-Fog lens coating to keep your lenses and vision clear
                    </p>
                </div>

                <div id="style-txt-goggles" style="display:none;" ref="style-txt-goggles">
                    <p><strong>GOGGLES DESIGN FEATURES:</strong><br />
                        Added protection from multiple hazards like liquid splash, impact, dust and airborne particles &bull; Choose from direct vent, indirect vent or non-vented to fit your application &bull; Styles available to fit comfortably over most prescription glasses &bull; Offered in a variety of frame materials and headband strap options &bull; Most styles offered with anti-fog lens coating  &bull; Modern wraparound styles offer a snug, comfortable fit with a wide viewing area &bull; Models to meet every price point
                    </p>
                </div>

            </div><!-- #style-txt -->

            <!-- <p class="expert-link">
                <a href="https://us.pipglobal.com/en/products/?scID=2562">View all Eye Protection products ></a>
            </p> -->

        </div><!-- expert-div -->

        <img src="/images/st-learning/tic-divider-gray.gif" class="expert-divider" />

        <div class="expert-div">

            <h2 class="none">Advanced Lens Technologies</h2>
            <p class="main">
                West Chester Protective Gear offers you the right lenses for your working environment. As a basic, we start with Anti-Scratch and Anti-Fog which is standard on many of our glasses. We offer special treatments to extend the life of your eyewear while helping you see better by filtering light and reducing glare.
            </p>

            <div id="lens-list">
                <VueSlickCarousel v-bind="settings">
                    <div>
                        <img src="/images/st-learning/eye-protection/img-lens-AR.jpg" />
                        <p>
                            <strong>Anti-Reflective</strong> <br />
                            <em>Reduce Reflection and Glare</em>
                        </p>

                        <p>
                            Anti-Reflective (AR) lens coating will improve visual acuity in any application by reducing reflections and improving visible light transmission.
                        </p>
                    </div>

                    <div>
                        <img src="/images/st-learning/eye-protection/img-lens-IO.jpg" />
                        <p>
                            <strong>Indoor/Outdoor Blue</strong> <br />
                            <em>Alleviate Digital Eye Strain</em>
                        </p>

                        <p>
                            Indoor/Outdoor Blue Lens is a proprietary engineered lens that combines a slight yellow tint and a mirror coating, working in tandem to alleviate and help to prevent digital eye strain.
                        </p>
                    </div>

                    <div>
                        <img src="/images/st-learning/eye-protection/img-lens-polarized.jpg" />
                        <p>
                            <strong>Polarized</strong> <br />
                            <em>Enhance Vision Outdoors</em>
                        </p>

                        <p>
                            A polarized lens that reduces glare in bright outdoor environments involving water, sand, rocks and concrete.
                        </p>
                    </div>

                    <div>
                        <img src="/images/st-learning/eye-protection/img-lens-gradient.jpg" />
                        <p>
                            <strong>Gradient</strong> <br />
                            <em>Reduce Overhead Light Glare</em>
                        </p>

                        <p>
                            Gradient tint lenses have a slight mirror coating on the top portion of the clear lens. This tint reduces glare from high-powered overhead fluorescent and mercury lighting helping to minimize squinting eye strain.
                        </p>
                    </div>

                    <div>
                        <img src="/images/st-learning/eye-protection/img-lens-mirror.jpg" />
                        <p>
                            <strong>Mirror Plus</strong> <br />
                            <em>Protect from Bright Sunlight</em>
                        </p>

                        <p>
                            Mirror coated lenses with Anti-Reflective (AR) coating on the inside will protect against bright sunlight and provide clearer vision through the lens when compared to a standard shaded lens.
                        </p>
                    </div>
                </VueSlickCarousel>
            </div>

            <!-- <p class="expert-link">
                <a href="https://us.pipglobal.com/en/products/?scID=2562">View all Eye Protection products ></a>
            </p> -->
        </div><!-- expert-div -->

        <img src="/images/st-learning/tic-divider2-gray.gif" class="expert-divider" />

        <div class="expert-div">

            <h2>Lens Colors</h2>

            <p class="main">
                West Chester Protective Gear safety glasses are available in multiple lens colors. These various lens tints all serve a specific purpose, depending on your task, the lighting conditions, and your work environment.
            </p>

            <div id="lens-list-med">
                <VueSlickCarousel v-bind="settings">
                    <div>
                        <img src="/images/st-learning/eye-protection/img-lens-clear.jpg" width="127" height="79" />
                        <p>
                            <strong>Clear</strong><br />
                            <em>Visible light transmission: 90%</em>
                            <br />For general use. No color distortion, all polycarbonate has 99.9% UV absorption.
                        </p>
                    </div>

                    <div>
                        <img src="/images/st-learning/eye-protection/img-lens-amber.jpg" width="127" height="79" />
                        <p>
                            <strong>Amber</strong><br />
                            <em>Visible light transmission: 82%</em>
                            <br />Enhances visual acuity. Ideal for professional drivers in foggy, rainy, or snowy conditions.
                        </p>
                    </div>

                    <div>
                        <img src="/images/st-learning/eye-protection/img-lens-blue.jpg" width="127" height="79" />
                        <p>
                            <strong>Light Blue</strong><br />
                            <em>Visible light transmission: 58%</em>
                            <br />Relieves eye strain from bright, overhead fluorescent lighting.
                        </p>
                    </div>

                    <div>
                        <img src="/images/st-learning/eye-protection/img-lens-gray.jpg" width="127" height="79" />
                        <p>
                            <strong>Gray</strong><br />
                            <em>Visible light transmission: 12%</em>
                            <br />Darkening effect with little color distortion, best used outdoors in bright sun.
                        </p>
                    </div>

                    <div>
                        <img src="/images/st-learning/eye-protection/img-lens-brown.jpg" width="127" height="79" />
                        <p>
                            <strong>Brown</strong><br />
                            <em>Visible light transmission: 12%</em>
                            <br />Darkening effect with improved color contrast. Best used outdoors in nature - green colors enhanced.
                        </p>
                    </div>

                    <div>
                        <img src="/images/st-learning/eye-protection/img-lens-IR3.jpg" width="127" height="79" />
                        <p>
                            <strong>IR Filter Shade 3.0</strong><br />
                            <em>Visible light transmission: 10%</em>
                            <br />Protection from welding arc and IR light. Not to be used for welding or when operating vehicles.
                        </p>
                    </div>

                    <div>
                        <img src="/images/st-learning/eye-protection/img-lens-IR5.jpg" width="127" height="79" />
                        <p>
                            <strong>IR Filter Shade 5.0</strong><br />
                            <em>Visible light transmission: 2%</em>
                            <br />Protection from welding arc and IR light. Not to be used for welding or when operating vehicles.
                        </p>
                    </div>
                </VueSlickCarousel>
            </div>

            <!-- <p class="expert-link">
                <a href="https://us.pipglobal.com/en/products/?scID=2562">View all Eye Protection products ></a>
            </p> -->

        </div><!-- expert-div -->

        <img src="/images/st-learning/tic-divider-gray.gif" class="expert-divider" />

        <div class="expert-div">

            <h2>Lens Coatings</h2>

            <p class="main">
                West Chester Protective Gear lens coating options have a major impact on the effectiveness of the safety eyewear in the workplace. Choosing the right coatings can not only help keep your eyes safe, but can also translate into increased productivity.
            </p>

            <div id="lens-list-med">
                <VueSlickCarousel v-bind="settings">
                    <div>
                        <img src="/images/st-learning/eye-protection/img-lens-AS.jpg" width="100" />
                        <p>
                            <strong>Anti-Scratch (AS)</strong>
                            <br />Hardcoat treatment that toughens lens surface for a longer product life with fewer scratches.
                        </p>
                    </div>
                    <div>
                        <img src="/images/st-learning/eye-protection/img-lens-AF.jpg" width="100" />
                        <p>
                            <strong>Anti-Fog (AF)</strong>
                            <br />Surface coating that reduces fogging, maintaining clear vision. Ideal for food plants or cleaning operations with high-humidity environments
                        </p>
                    </div>
                    <div>
                        <img src="/images/st-learning/eye-protection/img-lens-inout.jpg" width="100" />
                        <p>
                            <strong>Indoor/Outdoor</strong>
                            <br />Light mirror coating on clear lens, giving enough light transmission to work indoors while reducing pupil adjustment time
                        </p>
                    </div>
                    <div>
                        <img src="/images/st-learning/eye-protection/img-lens-mirrorr.jpg" width="100" />
                        <p>
                            <strong>Mirror</strong>
                            <br />Front surface coating reflects light from lens, great for bright environments in snow, sand and water
                        </p>
                    </div>
                </VueSlickCarousel>
            </div>

            <!-- <p class="expert-link">
                <a href="https://us.pipglobal.com/en/products/?scID=2562">View all Eye Protection products ></a>
            </p> -->

        </div><!-- expert-div -->

        <img src="/images/st-learning/tic-divider2-gray.gif" class="expert-divider" />

        <div class="expert-div" style="border-bottom:none;">

            <h2 class="none">Readers</h2>
            <p class="main">
                West Chester Protective Gear offers several styles of magnification reader glasses. Several are offered in increments of 0.25 diopters (magnification power), so you can offer your workers the correct magnification they need, instead of "close enough".
            </p>

            <p>
                <img src="/images/st-learning/eye-protection/img-eyewear-readers.jpg" id="eyewear-readers" />

            <ul id="diopters">
                <li style="background-color:#B9A9ED;">
                    <p>
                        LOW<br />
                        <strong>+1.00</strong>
                    </p>
                </li>
                <li style="background-color:#908FDB;">
                    <p>
                        LOW<br />
                        <strong>+1.25</strong>
                    </p>
                </li>
                <li style="background-color:#71A7F9;">
                    <p>
                        LOW<br />
                        <strong>+1.50</strong>
                    </p>
                </li>
                <li style="background-color:#0DCD6B;">
                    <p>
                        MEDIUM<br />
                        <strong>+1.75</strong>
                    </p>
                </li>
                <li style="background-color:#7EDC44;">
                    <p>
                        MEDIUM<br />
                        <strong>+2.00</strong>
                    </p>
                </li>
                <li style="background-color:#FFCE00;">
                    <p>
                        STRONG<br />
                        <strong>+2.25</strong>
                    </p>
                </li>
                <li style="background-color:#F88300;">
                    <p>
                        STRONG<br />
                        <strong>+2.50</strong>
                    </p>
                </li>
                <li style="background-color:#DC241F;">
                    <p>
                        STRONG<br />
                        <strong>+3.00</strong>
                    </p>
                </li>
            </ul>

            </p>
            <div class="clear"></div>

            <!-- <p class="expert-link">
                <a href="https://us.pipglobal.com/en/products/?scID=2562">View all Eye Protection products ></a>
            </p> -->
        </div><!-- expert-div -->
    </div>
</template>

<script>
    import VueSlickCarousel from "vue-slick-carousel";
    import "vue-slick-carousel/dist/vue-slick-carousel.css";
    import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";
    export default {
        data() {
            return {
            name: 'Vue.js',
            settings: {
                  "autoplay": false,
                  "focusOnSelect": true,
                  "infinite": false,
                  "pauseOnFocus": true,
                  "slidesToShow": 3,
                  "speed": 500,
                  "arrows":true,
                  responsive: [
                      {
                      breakpoint: 1000,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 1,
                        },
                      },
                      {
                      breakpoint: 500,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                        },
                      }
                    ]
                }
            }
        },

        methods: {
            techHover(event) {
                if(event){
                    var hoveredID = event.target.id;
                    switch(hoveredID) {
                        case "style-th-rimless":
                        case "style-th-rimless-img":
                            //title
                            this.$refs['style-th-rimless'].style="border-bottom:solid 3px #cd1b00;";
                            this.$refs['style-th-semi-rimless'].style="border-bottom: none";
                            this.$refs['style-th-full-frame'].style="border-bottom: none";
                            this.$refs['style-th-hybrid'].style="border-bottom: none";
                            this.$refs['style-th-goggles'].style="border-bottom: none";
                            //image
                            this.$refs['style-img-rimless'].style="display: block";
                            this.$refs['style-img-semi-rimless'].style="display: none";
                            this.$refs['style-img-full-frame'].style="display: none";
                            this.$refs['style-img-hybrid'].style="display: none";
                            this.$refs['style-img-goggles'].style="display: none";
                            //text
                            this.$refs['style-txt-rimless'].style="display: block";
                            this.$refs['style-txt-semi-rimless'].style="display: none";
                            this.$refs['style-txt-full-frame'].style="display: none";
                            this.$refs['style-txt-hybrid'].style="display: none";
                            this.$refs['style-txt-goggles'].style="display: none";
                            break;
                        case "style-th-semi-rimless":
                        case "style-th-semi-rimless-img":
                            //title
                            this.$refs['style-th-rimless'].style="border-bottom: none";
                            this.$refs['style-th-semi-rimless'].style="border-bottom:solid 3px #cd1b00;";
                            this.$refs['style-th-full-frame'].style="border-bottom: none";
                            this.$refs['style-th-hybrid'].style="border-bottom: none";
                            this.$refs['style-th-goggles'].style="border-bottom: none";
                            //image
                            this.$refs['style-img-rimless'].style="display: none";
                            this.$refs['style-img-semi-rimless'].style="display: block";
                            this.$refs['style-img-full-frame'].style="display: none";
                            this.$refs['style-img-hybrid'].style="display: none";
                            this.$refs['style-img-goggles'].style="display: none";
                            //text
                            this.$refs['style-txt-rimless'].style="display: none";
                            this.$refs['style-txt-semi-rimless'].style="display: block";
                            this.$refs['style-txt-full-frame'].style="display: none";
                            this.$refs['style-txt-hybrid'].style="display: none";
                            this.$refs['style-txt-goggles'].style="display: none";
                            break;
                        case "style-th-full-frame":
                        case "style-th-full-frame-img":
                            //title
                            this.$refs['style-th-rimless'].style="border-bottom: none";
                            this.$refs['style-th-semi-rimless'].style="border-bottom: none";
                            this.$refs['style-th-full-frame'].style="border-bottom: solid 3px #cd1b00;";
                            this.$refs['style-th-hybrid'].style="border-bottom: none";
                            this.$refs['style-th-goggles'].style="border-bottom: none";
                            //image
                            this.$refs['style-img-rimless'].style="display: none";
                            this.$refs['style-img-semi-rimless'].style="display: none";
                            this.$refs['style-img-full-frame'].style="display: block";
                            this.$refs['style-img-hybrid'].style="display: none";
                            this.$refs['style-img-goggles'].style="display: none";
                            //text
                            this.$refs['style-txt-rimless'].style="display: none";
                            this.$refs['style-txt-semi-rimless'].style="display: none";
                            this.$refs['style-txt-full-frame'].style="display: block";
                            this.$refs['style-txt-hybrid'].style="display: none";
                            this.$refs['style-txt-goggles'].style="display: none";
                            break;
                        case "style-th-hybrid":
                        case "style-th-hybrid-img":
                            //title
                            this.$refs['style-th-rimless'].style="border-bottom: none";
                            this.$refs['style-th-semi-rimless'].style="border-bottom: none";
                            this.$refs['style-th-full-frame'].style="border-bottom: none";
                            this.$refs['style-th-hybrid'].style="border-bottom: solid 3px #cd1b00;";
                            this.$refs['style-th-goggles'].style="border-bottom: none";
                            //image
                            this.$refs['style-img-rimless'].style="display: none";
                            this.$refs['style-img-semi-rimless'].style="display: none";
                            this.$refs['style-img-full-frame'].style="display: none";
                            this.$refs['style-img-hybrid'].style="display: block";
                            this.$refs['style-img-goggles'].style="display: none";
                            //text
                            this.$refs['style-txt-rimless'].style="display: none";
                            this.$refs['style-txt-semi-rimless'].style="display: none";
                            this.$refs['style-txt-full-frame'].style="display: none";
                            this.$refs['style-txt-hybrid'].style="display: block";
                            this.$refs['style-txt-goggles'].style="display: none";
                            break;
                        case "style-th-goggles":
                        case "style-th-goggles-img":
                            //title
                            this.$refs['style-th-rimless'].style="border-bottom: none";
                            this.$refs['style-th-semi-rimless'].style="border-bottom: none";
                            this.$refs['style-th-full-frame'].style="border-bottom: none";
                            this.$refs['style-th-hybrid'].style="border-bottom: none";
                            this.$refs['style-th-goggles'].style="border-bottom: solid 3px #cd1b00;";
                            //image
                            this.$refs['style-img-rimless'].style="display: none";
                            this.$refs['style-img-semi-rimless'].style="display: none";
                            this.$refs['style-img-full-frame'].style="display: none";
                            this.$refs['style-img-hybrid'].style="display: none";
                            this.$refs['style-img-goggles'].style="display: block";
                            //text
                            this.$refs['style-txt-rimless'].style="display: none";
                            this.$refs['style-txt-semi-rimless'].style="display: none";
                            this.$refs['style-txt-full-frame'].style="display: none";
                            this.$refs['style-txt-hybrid'].style="display: none";
                            this.$refs['style-txt-goggles'].style="display: block";
                            break;
                    }
                    
                }
            },
            fitHover(fit){
                switch(fit){
                    case "fit-round-img":
                        this.$refs['fit-round-img'].src="/images/st-learning/eye-protection/fit-round-head.gif";
                        this.$refs['fit-avg-img'].src="/images/st-learning/eye-protection/fit-average-head-grey.gif";
                        this.$refs['fit-narrow-img'].src="/images/st-learning/eye-protection/fit-narrow-head-grey.gif";
                        this.$refs['fit-women-img'].src="/images/st-learning/eye-protection/fit-women-grey.gif";

                        this.$refs['fit-round'].style="display: block";
                        this.$refs['fit-avg'].style="display: none";
                        this.$refs['fit-narrow'].style="display: none";
                        this.$refs['fit-women'].style="display: none";
                        break;
                    case "fit-avg-img":
                        this.$refs['fit-round-img'].src="/images/st-learning/eye-protection/fit-round-head-grey.gif";
                        this.$refs['fit-avg-img'].src="/images/st-learning/eye-protection/fit-average-head.gif";
                        this.$refs['fit-narrow-img'].src="/images/st-learning/eye-protection/fit-narrow-head-grey.gif";
                        this.$refs['fit-women-img'].src="/images/st-learning/eye-protection/fit-women-grey.gif";

                        this.$refs['fit-round'].style="display: none";
                        this.$refs['fit-avg'].style="display: block";
                        this.$refs['fit-narrow'].style="display: none";
                        this.$refs['fit-women'].style="display: none";
                        break;
                    case "fit-narrow-img":
                        this.$refs['fit-round-img'].src="/images/st-learning/eye-protection/fit-round-head-grey.gif";
                        this.$refs['fit-avg-img'].src="/images/st-learning/eye-protection/fit-average-head-grey.gif";
                        this.$refs['fit-narrow-img'].src="/images/st-learning/eye-protection/fit-narrow-head.gif";
                        this.$refs['fit-women-img'].src="/images/st-learning/eye-protection/fit-women-grey.gif";

                        this.$refs['fit-round'].style="display: none";
                        this.$refs['fit-avg'].style="display: none";
                        this.$refs['fit-narrow'].style="display: block";
                        this.$refs['fit-women'].style="display: none";
                        break;
                    case "fit-women-img":
                        this.$refs['fit-round-img'].src="/images/st-learning/eye-protection/fit-round-head-grey.gif";
                        this.$refs['fit-avg-img'].src="/images/st-learning/eye-protection/fit-average-head-grey.gif";
                        this.$refs['fit-narrow-img'].src="/images/st-learning/eye-protection/fit-narrow-head-grey.gif";
                        this.$refs['fit-women-img'].src="/images/st-learning/eye-protection/fit-women.gif";

                        this.$refs['fit-round'].style="display: none";
                        this.$refs['fit-avg'].style="display: none";
                        this.$refs['fit-narrow'].style="display: none";
                        this.$refs['fit-women'].style="display: block";
                        break;
                }
            },
            showMobile(event) {
                if (event) {
                    this.$refs['mobileView'].style="display: block;";
                    this.$refs['readMore'].style="display: none;";
                    this.$refs['readLess'].style="display: block;";
                }
            },
            hideMobile(event) {
                if (event) {
                    this.$refs['mobileView'].style="display: none;";
                    this.$refs['readMore'].style="display: block;";
                    this.$refs['readLess'].style="display: none;";
                }
            },
            burgerClicked(id) {

                    if(id == "borger-1") {
                        if (this.$refs['top-dropdown'].style.display != "block") {
                        this.$refs['top-dropdown'].style="display: block;";
                        } else {
                            this.$refs['top-dropdown'].style="display: none;";
                        }
                    } else if(id == "borger-2") {
                        if (this.$refs['bottom-dropdown'].style.display != "block") {
                        this.$refs['bottom-dropdown'].style="display: block;";
                        } else {
                            this.$refs['bottom-dropdown'].style="display: none;";
                        }
                    }
            }
        },
        components: { VueSlickCarousel }
    }
</script>
